import { StateObservable } from 'redux-observable'
import { MessageWithId } from 'shared/typings/messages/Message'
import { MessageRecipientStatus, Status } from 'shared/typings/messages/MessageRecipientStatus'
import { MessageType } from 'shared/typings/messages/MessageType'
import { UserIdType } from 'shared/typings/users/UserIdType'

import {
  getConversation,
  getMostRecentReadMessageForConversation,
  getPendingReadReceiptForConversation,
} from './selectors'

export const isReadableMessageWithPendingReceipt =
  (state: StateObservable<any>) => (message: MessageWithId) => {
    if (
      message.type !== MessageType.PRIVATE_NOTE &&
      message.authorType !== UserIdType.END_USER &&
      message.authorType !== UserIdType.LEAD
    ) {
      const pending = getPendingReadReceiptForConversation(message.conversationId)(state.value)
      if (pending && pending === message.id) {
        return true
      }
    }
    return false
  }

export const endUserReceivedMessage =
  (state: StateObservable<any>) => (payload: MessageRecipientStatus) => {
    const conversation = getConversation(payload.conversationId)(state.value)
    return conversation
      ? conversation.endUserId === payload.recipientId &&
          (payload.recipientType === UserIdType.END_USER ||
            payload.recipientType === UserIdType.LEAD)
      : false
  }

export const newReceiptIsMostRecent =
  (state: StateObservable<any>) => (payload: MessageRecipientStatus) => {
    const mostRecentMessage = getMostRecentReadMessageForConversation(payload.conversationId)(
      state.value
    )
    return !!(!mostRecentMessage || payload.messageId > mostRecentMessage)
  }

const messageWasReadByEndUser = (message: MessageWithId) => {
  const { recipientStatuses } = message

  return (
    recipientStatuses &&
    Object.keys(recipientStatuses)
      .filter((key) => key.includes(UserIdType.LEAD) || key.includes(UserIdType.END_USER))
      .some((key) => recipientStatuses[key] === Status.Read)
  )
}

export const isMostRecentlyReadMessageByEndUser =
  (mostRecentMessage: number) => (message: MessageWithId) => {
    if (!mostRecentMessage || message.id > mostRecentMessage) {
      const { recipientStatuses } = message
      if (
        message.type !== MessageType.PRIVATE_NOTE &&
        message.authorType === UserIdType.USER &&
        recipientStatuses &&
        messageWasReadByEndUser(message)
      ) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }

export const isNotEndUserMessage =
  (state: StateObservable<any>) =>
  (payload: MessageRecipientStatus) =>
  (message: MessageWithId) => {
    const conversation = getConversation(payload.conversationId)(state.value)
    return message && conversation ? message.authorId !== conversation.endUserId : false
  }
